import React from 'react';
import MainLayout from '../components/layouts/MainLayout';
import QuestionnaireDetails from '../pages/QuestionnaireDetails/QuestionnaireDetails';
import QuestionnaireStart from '../pages/QuestionnaireStart/QuestionnaireStart';
import Home from '../pages/Home';
import ResultContainer from '../components/Score/ResultContainer.jsx';  


const routes = [
  {
    path: '/',
    element: <MainLayout children={<Home />} />,
  },
  {
    path: '/questionnaire/:id',
    element: <MainLayout children={<QuestionnaireDetails />} />,
  },
  {
    path: '/questionnaire/:id/start',
    element: <MainLayout children={<QuestionnaireStart />} />,
  },
  {
    path: '/survey/questionnaires/submission/:id/result/',
    element: <MainLayout children={<ResultContainer />} />,
  },

];

export default routes;
